export { default as useCacheSuggestProducts } from './useCacheSuggestProducts';
